import Api from '../Base'

class GetUserInfo extends Api {
  requestUrl = `/api/user/${this.getParams().id}`
}

export default GetUserInfo
